<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Energy_usage') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('comparison_tooltip_energy_use')"></i>
    </div>
    <div class="card-body text-center">
      <LoadingSpinner v-if="loading"></LoadingSpinner>
      <div v-show="!loading" id="canvas-energyusage"></div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'EnergyUsageBars',
  components: {
    LoadingSpinner
  },
  data(){
    return {
      chart: null,
      sec: 0,
      clock: null
    }
  },
  mounted:function(){
    const self = this
    this.chart = Highcharts.chart('canvas-energyusage', {
        chart: {
          type: 'columnrange',
          inverted: true,
          backgroundColor: '#fff'
        },
        credits: { enabled: false },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            formatter: function () {
              return Math.abs(this.value);
            }
          }
        },
        tooltip: {
          shared:true,
          pointFormatter: function () {
            var value = this.high - this.low;
            return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + Highcharts.numberFormat(value, 2) + ' kWh</b> <br/>';
          }
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            events: {
              legendItemClick: function () {
                if (this.visible) _paq.push(['trackEvent', 'Comparação', 'Gráfico Uso de energia', 'Esconder (' + this.name + ')'])                        
                else _paq.push(['trackEvent', 'Comparação', 'Gráfico Uso de energia', 'Mostrar (' + this.name + ')'])
              },
              mouseOver: function () {
                self.clock = setInterval(function(){ self.sec++;  }, 1000)
              },
              mouseOut: function () {
                clearInterval(self.clock);
                if(self.sec > 1) _paq.push(['trackEvent', 'Comparação', 'Gráfico Uso de energia', 'MouseOver (' + this.name + ')', self.sec])
                self.sec = 0
              }
            }
          },
          columnrange: {
            dataLabels: {
              enabled: true,
              align: 'center',
              color: '#000',
              style: { 
                  fontSize: '14px',
                  textOutline: '0px contrast'
              },
              formatter: function() 
              {
                if (this.y === this.point.low || this.y === this.point.high) {
                  if(this.series.id == 3)
                    if (((this.point.high - this.point.low) / this.point.low) > 0.25) 
                      return (this.point.high - this.point.low).toFixed(2) 
                    else return ''
                  else 
                    return (this.point.high - this.point.low).toFixed(2) 
                } 
                else return ''
              }
            }
          }
      },
      legend: {
        enabled: true
      },
      exporting: false,
      series: [
        {
            name: this.$i18n.t('Consumption'),
            data: [],
            id: 0,
            color: '#f7882f' //'#f9a93e'//
        },
        {
            name: this.$i18n.t('Electric_grid'),
            data: [],
            id: 1,
            color: '#ef5e3c', //'#3c9c3d',
            stack: 'normal'
        },
        {
            name: this.$i18n.t('Production_used'),
            data: [],
            id: 2,
            color: '#4187c7',
            stack: 'normal'
        },
        {
            name: this.$i18n.t('Production_not_used'),
            data: [],
            id: 3,
            color: '#53c8eb',
            stack: 'normal'
        }
      ]
    })
  },
  methods: {
    set_values: function(){
      let legend1 = ""
      let legend2 = ""

      if (this.range == 'day'){
        legend1 = moment(this.datetime1).format('DD MMM YYYY')
        legend2 = moment(this.datetime2).format('DD MMM YYYY')
      } 
      else if (this.range == 'week') {
        legend1 = moment(this.datetime1).format('DD') +'-' + moment(this.datetime1).add(6, "days").format('DD MMM YYYY')
        legend2 = moment(this.datetime2).format('DD') +'-' + moment(this.datetime2).add(6, "days").format('DD MMM YYYY')
      }
      else if (this.range == 'month'){
        legend1 = moment(this.datetime1).format('MMM YYYY')
        legend2 = moment(this.datetime2).format('MMM YYYY')
      }

      this.chart.xAxis[0].setCategories([legend1, legend2])
      /* this.chart.series[0].setData([ [-this.data[0].consumed_from_purchased, this.data[0].consumed_from_produced], [-this.data[1].consumed_from_purchased, this.data[1].consumed_from_produced] ], false)
      this.chart.series[1].setData([ [-this.data[0].consumed_from_purchased, 0], [-this.data[1].consumed_from_purchased, 0] ], false)
      this.chart.series[2].setData([ [0, this.data[0].consumed_from_produced], [0, this.data[1].consumed_from_produced] ], false)
      this.chart.series[3].setData([ [this.data[0].consumed_from_produced, this.data[0].consumed_from_produced + this.data[0].wasted_from_produced], [this.data[1].consumed_from_produced, this.data[1].consumed_from_produced + this.data[1].wasted_from_produced] ], false) */
      
      this.chart.series[0].setData([ [-this.data[0].Grid_House, this.data[0].PV_House], [-this.data[1].Grid_House, this.data[1].PV_House] ], false)
      this.chart.series[1].setData([ [-this.data[0].Grid_House, 0], [-this.data[1].Grid_House, 0] ], false)
      this.chart.series[2].setData([ [0, this.data[0].PV_House], [0, this.data[1].PV_House] ], false)
      this.chart.series[3].setData([ [this.data[0].PV_House, this.data[0].PV_House + this.data[0].PV_Grid], [this.data[1].PV_House, this.data[1].PV_house + this.data[1].PV_Grid] ], false)


      if(!this.chart.hasData()){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t("No_Data"))
      }
      this.chart.redraw()
    }
  },
  watch: {
    data: function(){
      this.set_values()
    },
    current_lang: function(){
      this.chart.series[0].update({name: this.$i18n.t('Consumption')}, false);
      this.chart.series[1].update({name: this.$i18n.t('Electric_grid')}, false);
      this.chart.series[2].update({name: this.$i18n.t('Production_used')}, false);
      this.chart.series[3].update({name: this.$i18n.t('Production_not_used')}, false);
      this.set_values()
    }
  },
  computed:{
    data: function(){
      return this.$store.getters.data_energyUsed_comparison
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    range: function(){
      return this.$store.getters.selected_range
    },
    datetime1: function(){
      return this.$store.getters.datetime1
    },
    datetime2: function(){
      return this.$store.getters.datetime2
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
